import React from 'react';
import './navfooter.scss';
import { useSelector } from 'react-redux';
import lang from '../../lang/lang.json';

const FooterLegalInfo = () => {
  const { language } = useSelector((state) => state.language);

  return (
    <div className="foot-nav-legal legalinfo">
      <div className="footer-items-legal">
        {lang.ALIF_LICENSE_TEXT[language]}
      </div>
      <div className="root-lang mobile-change">
        {lang.ALIF_LICENSE_DATE[language]}
      </div>
    </div>
  );
};

export default FooterLegalInfo;
